import { TextField } from "@mui/material";
import type { FC } from "react";
import { Controller, useFormContext, useWatch } from "react-hook-form";
import { useTranslation } from "react-i18next";
import type { PollPresets } from "../hooks/use-poll-default-values";
import { PollHelperText } from "../poll-helper-text";
import type { PollWrapperSchema } from "../types";
import { PollFormCustomAnswerType } from "./poll-form-custom-answer-type";
import { PollFormNonCustomAnswerPreview } from "./poll-form-non-custom-answer-preview";
import { PollFormSelectAnswerType } from "./poll-form-select-answer-type";

export const PollFormCustom: FC<{
  presets: PollPresets;
}> = ({ presets }) => {
  const { t } = useTranslation();

  const { control, getValues } = useFormContext<PollWrapperSchema>();

  useWatch({ control, name: "poll.answer_type.type" });
  const answer_type = getValues("poll.answer_type.type");

  return (
    <>
      <Controller
        name="poll.question"
        control={control}
        render={({ field, fieldState }) => (
          <TextField
            label={t("Question text")}
            {...field}
            fullWidth
            error={!!fieldState.error}
            helperText={fieldState.error?.message}
          />
        )}
      />
      <PollFormSelectAnswerType presets={presets.options} />
      <PollHelperText />
      {answer_type === "custom" && <PollFormCustomAnswerType />}
      {answer_type === "preset" && <PollFormNonCustomAnswerPreview />}
    </>
  );
};
